<template>
  <div :class="{ show: state.isShow }" ref="searchContainer">
    <input
      type="text"
      id="search-lots"
      v-model="state.searchText"
      :placeholder="trans('live.catalog.search.search_placeholder')"
      class="input filter-search-input"
      @keyup.enter="clickToIcon" />

    <button @click.prevent="clickToIcon" class="search-btn">
      <svg class="icon-search">
        <use href="/sprite.svg#search"></use>
      </svg>
    </button>

    <button v-if="state.isShow" class="search-btn clear" @click="clearSearch">
      <base-icon class="icon-close" icon-name="close" width="12" height="12" viewBox="0 0 26.87 26.87">
        <close-icon></close-icon>
      </base-icon>
    </button>
  </div>
</template>

<script setup lang="ts">
  import { onMounted, reactive, watch } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { BaseIcon, CloseIcon } from "@/components/icons";
  import { trans } from "@/utils/trans";

  const auctionStore = useAuctionStore();

  const state = reactive({
    isShow: false,
    searchText: "" as string | null
  });

  watch(
    () => auctionStore.catalog.searchString,
    (nv) => {
      if (nv?.length) {
        state.isShow = true;
      }

      state.searchText = auctionStore.catalog.searchString;
    }
  );

  const clearSearch = () => {
    auctionStore.catalog.searchString = null;
    auctionStore.catalog.searchLots = null;
    state.isShow = false;
  };

  const clickToIcon = () => {
    if (!state.isShow) {
      state.isShow = true;
    } else {
      auctionStore.catalog.searchString = state.searchText;
    }
  };

  onMounted(() => {
    if (auctionStore.catalog.searchString?.length) {
      state.isShow = true;
      state.searchText = auctionStore.catalog.searchString;
    }
  });
</script>

<style lang="scss" scoped>
  .search-block {
    position: relative;
    min-width: 29px;
    margin-left: 25px;

    &.show {
      .input {
        pointer-events: auto;
        opacity: 1;

        &:focus,
        &:focus-visible,
        &:focus-within {
          border-color: #2a3644;
        }
      }
    }

    .input {
      pointer-events: none;
      width: 240px;
      opacity: 0;
      position: absolute;
      height: 36px;
      transition: 0.2s opacity linear;
      padding: 7px 32px 7px 17px;
      border: 1px solid #dddddd;
      right: 0;
      z-index: 1;

      .live-catalog-modal & {
        position: relative;
      }
    }

    .search-btn {
      position: absolute;
      top: 10px;
      right: 1px;
      background: #fff;
      padding-right: 10px;
      z-index: 1;

      &.clear {
        width: 18px;
        height: 18px;
        padding-right: 0;
        right: 40px;
      }
    }

    .icon-close {
      width: 18px;
      height: 18px;
      color: #707070;
    }
  }

  @media (max-width: 1024px) {
    .search-block {
      .search-btn {
        top: 0;
      }
      .input {
        top: -10px;
      }
    }
  }
</style>
